import ApplyGiftcard from '@/components/modules/checkout/ApplyGiftcard/ApplyGiftcard';
import Modal from '@/components/modules/modals/redesign/Modal/Modal';
import { bookConstants } from '@/constants';
import { classnames } from '@/helpers';
import { useAppDispatch, useAppSelector } from '@/hooks';
import useMobileView from '@/hooks/useMobileView';
import { _s } from '@/locale';
import { SelectedPaymentMethod } from '@/types/checkout';
import { UseCheckoutModalManagerResult } from './CheckoutModal.hooks';

const baseTranslationKey = 'components.modules.checkout.CheckoutModal';

export type CheckoutModalScreen = 'list' | 'cof' | 'applyGiftcard';

export type CheckoutModalProps = {
  selectedPaymentMethod: SelectedPaymentMethod;
  onChangePaymentMethod: (method: SelectedPaymentMethod) => void;
  onApplyGiftcard?: (code: string) => void;
  onClose?: () => void;
} & UseCheckoutModalManagerResult;

const CheckoutModal = ({ isOpen, screen, onApplyGiftcard, onClose }: CheckoutModalProps) => {
  const bookState = useAppSelector((state) => state.book);
  const appDispatch = useAppDispatch();
  const { errorGiftCard, validateGiftCard } = bookState;
  const { isMobileView } = useMobileView();

  const handleOnAppyGiftcard = (code: string) => {
    if (screen === 'applyGiftcard') {
      if (code.toLowerCase().startsWith('f-')) {
        appDispatch({ type: bookConstants.ERROR_GIFTCARD, error: _s('invalidGiftcardCode') });
        return;
      }
    }

    if (screen === 'applyWellnesscard') {
      if (!code.toLowerCase().startsWith('f-')) {
        appDispatch({ type: bookConstants.ERROR_GIFTCARD, error: _s('invalidWellnesscardCode') });
        return;
      }
    }

    onApplyGiftcard(code);
  };

  return (
    <Modal isOpen={isOpen}>
      <Modal.Content floating={!isMobileView}>
        <Modal.Header title={_s(`${baseTranslationKey}.title.${screen}`)} onClose={onClose} />
        <div className={classnames(isMobileView && 'px-lg')}>
          {screen === 'applyGiftcard' && (
            <ApplyGiftcard
              type="giftcard"
              onApplyGiftcard={handleOnAppyGiftcard}
              error={errorGiftCard}
              validating={validateGiftCard}
            />
          )}
          {screen === 'applyValuecard' && (
            <ApplyGiftcard
              type="valuecard"
              onApplyGiftcard={handleOnAppyGiftcard}
              error={errorGiftCard}
              validating={validateGiftCard}
            />
          )}
          {screen === 'applyWellnesscard' && (
            <ApplyGiftcard
              type="wellnesscard"
              onApplyGiftcard={handleOnAppyGiftcard}
              error={errorGiftCard}
              validating={validateGiftCard}
            />
          )}
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default CheckoutModal;
